import { render, staticRenderFns } from "./registerInformation.vue?vue&type=template&id=0238fee5&scoped=true&"
import script from "./registerInformation.vue?vue&type=script&lang=js&"
export * from "./registerInformation.vue?vue&type=script&lang=js&"
import style0 from "./registerInformation.vue?vue&type=style&index=0&id=0238fee5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238fee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0238fee5')) {
      api.createRecord('0238fee5', component.options)
    } else {
      api.reload('0238fee5', component.options)
    }
    module.hot.accept("./registerInformation.vue?vue&type=template&id=0238fee5&scoped=true&", function () {
      api.rerender('0238fee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/registerInformation.vue"
export default component.exports